import * as React from 'react';
import * as I18n from 'i18n-js';
import * as classNames from 'classnames';

import { Paths } from '../url_helpers';
import { useUser } from '../user_hooks';
import { isExperimentEnabled } from '../user_context_helpers';
import { getItem } from '../local_storage_utils';
import { experiments } from '../constants';
import { compact, reject, sampleSize, trim } from 'lodash';
import CoreLink from './core_link';
import { MParticleEventName } from '../elog/mparticle_tracker';
import { formatExperimentsForEventAttributes } from '../elog/mparticle';
import { useViewTracking } from '../use_tracking';

export const SUGGESTION_LIMIT = 5;
const COMPONENT_NAME = 'RecentSearches';

interface IProps {
  defaultSuggestions: string[];
}

function hydrate(setRecentSearches) {
  let recentSearches: string[] = compact(getItem('RECENT_SEARCHES') || []);

  recentSearches = reject(
    recentSearches.map(s => trim(s)),
    s => s === '',
  );

  setRecentSearches(recentSearches);
}

function getExperiments(user) {
  return formatExperimentsForEventAttributes(user, [
    experiments.RECENT_SEARCH_SUGGESTIONS,
  ]);
}

function getLabel(hasRecentSearches, recentSearches) {
  return !hasRecentSearches ?
    'suggestions:df' :
    `suggestions:rs:${recentSearches.length}`;
}

export default function RecentSearches(props: IProps) {
  const user = useUser();
  const [recentSearches, setRecentSearches] = React.useState<[] | null>(null);
  const loading = recentSearches === null;
  const hasRecentSearches = !loading && recentSearches.length > 0;

  const suggestions = hasRecentSearches ?
    recentSearches.slice(0, SUGGESTION_LIMIT) :
    sampleSize(props.defaultSuggestions, SUGGESTION_LIMIT);

  React.useEffect(() => hydrate(setRecentSearches), []);

  const mParticleViewData = {
    componentName: 'RecentSearchesRow',
    eventName: MParticleEventName.ComponentView,
    experiments: getExperiments(user),
    displayStyle: getLabel(hasRecentSearches, recentSearches),
  };

  useViewTracking(mParticleViewData, !loading);

  if (!isExperimentEnabled(user, experiments.RECENT_SEARCH_SUGGESTIONS)) { return null; }

  const classes = classNames(
    'search-header__suggestions',
    { 'search-header__suggestions--hidden': loading },
  );

  const clickEvent = {
    componentName: COMPONENT_NAME,
    eventName: MParticleEventName.ClickedSearchSuggestion,
    experiments: getExperiments(user),
  };

  return (
    <div className={classes}>
      <p className="search-header__suggestions-title">
        {hasRecentSearches ?
          I18n.t('commons.searchHeader.pickUp') :
          I18n.t('commons.searchHeader.needInspiration')}
      </p>
      {suggestions.map((suggestion, index) => {
        return (
          <CoreLink
            className="search-header__suggestion"
            to={Paths.marketplace.expand({ query: suggestion })}
            key={index}
            clickEvent={{ ...clickEvent, position: index }}
          >
            {suggestion}
          </CoreLink>
        );
      })}
    </div>
  );
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/src/components/recent_searches.tsx